import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ReservaService} from './servicios/reserva.service';
import { HttpClientModule } from '@angular/common/http';
import { TimepickerComponent } from './components/timepicker/timepicker.component';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule 
  ],
  providers: [
    ReservaService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
